import { Injectable } from '@angular/core';
import { User } from 'src/app/models/user';
@Injectable({
  providedIn: 'root',
})
export class LocalStorageService {
  constructor() {}

  getItem(key: any) {
    return localStorage.getItem(key);
  }
  setItem(key: any, value: any) {
    return localStorage.setItem(key, value);
  }
  removeItem(key: any) {
    localStorage.removeItem(key);
  }
  removeAllItems() {
    localStorage.clear();
  }
  getAllItems() {
    return localStorage;
  }
  setCookies(cookieName: string, cookieValue: any, day: number) {
    let cookieString = `${cookieName}=${cookieValue};path=/`;
    if (day > 0) {
      const date = new Date();
      date.setTime(date.getTime() + day * 24 * 60 * 60 * 1000);
      const expires = 'expires=' + date.toUTCString();
      cookieString = `${cookieName}=${cookieValue};${expires};path=/`;
    }
    document.cookie = cookieString;
  }
  getCookie(cookieName: string) {
    const name = cookieName + '=';
    const decodedCookie = decodeURIComponent(document.cookie);
    const cookieArray = decodedCookie.split(';');

    for (const cookie of cookieArray) {
      const trimmedCookie = cookie.trim();
      if (trimmedCookie.indexOf(name) === 0) {
        return trimmedCookie.substring(name.length);
      }
    }
    return '';
  }
}
